import { useAtom } from 'jotai';
import { providerAtom } from '../web3Store.atoms';
import { EWalletType } from '../web3Store.enums';
import { TProviderMap } from '../web3Store.type';

export default function useProvider<T extends EWalletType>(type: T): [TProviderMap[T] | undefined] {
	const [provider] = useAtom(providerAtom(type));
	return [provider as TProviderMap[T]];
}
